import { render, staticRenderFns } from "./gdot-preview.vue?vue&type=template&id=e1a1a626&"
import script from "./gdot-preview.ts?vue&type=script&lang=ts&"
export * from "./gdot-preview.ts?vue&type=script&lang=ts&"
import style0 from "./gdot-preview.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports